<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <b-container fluid>
        <b-form @submit.prevent="createLead">
          <h1 class="title mb-3">Add New Broker</h1>
          <div class="card">
            <div class="card-body p-2">
              <div class="form-group p-2 mb-1">
                <label for="brokerName">Broker Name<span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Broker Name"
                  required
                  ref="name"
                  v-model="$v.lead.full_name.$model"
                />
                  <div class="error" v-if="$v.lead.full_name.$error">Field is required</div>
              </div>

              <div class="form-group p-2 mb-1">
                <label for="firmName">Firm Name<span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Firm Name"
                  required
                  ref="firmName"
                  v-model="$v.lead.firm_name.$model"
                />
                <div class="error" v-if="$v.lead.firm_name.$error">Field is required</div>
              </div>

              <div class="form-group p-2 mb-0">
                <label for="firmName">Select Locality</label>

                <SingleTagInput
                  textLabel="Locality"
                  :masterList="localityList"
                  :addItem="selectLocality"
                  :removeItem="removeLocality"
                  :selectedItem="selectedLocality"
                />
              </div>
              <div class="form-group p-2 mb-0">
                <label for="firmName">Select Status<span class="text-danger">*</span></label>
                <SingleTagInput
                  textLabel="Lead Status"
                  :masterList="statusList"
                  :addItem="selectStatus"
                  :removeItem="removeStatus"
                  :selectedItem="selectedStatus"
                />
                <div class="error" v-if="hasStatusError && $v.selectedStatus.$invalid">
                  Field is required
                </div>
              </div>
              <div class="form-group p-2 mb-1" v-if="canShowEmpanelmentDate">
                <label for="empanelmentdate">Empanelment Date<span class="text-danger">*</span></label>
                <input
                  type="date"
                  class="form-control"
                  placeholder="Empanelment Date"
                  required
                  ref="empanelmentdate"
                  v-model="lead.empanelment_done_date"
                />
                <div class="error" v-if="$v.lead.firm_name.$error">Field is required</div>
              </div>
              <div class="form-group p-2 mb-1">
                <label for="firmAddress">Firm Address</label>
                <textarea
                  type="text"
                  class="form-control"
                  placeholder="Enter Address"
                  ref="firmAddress"
                  rows="3"
                  v-model="lead.address_line_1"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body p-2">
              <div class="form-group p-2 mb-1">
                <label for="mobileNumber">Mobile Number<span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Mobile Number"
                  required
                  ref="mobileNumber"
                  v-model="$v.lead.primary_phone.$model"
                />
                  <div class="error">{{validationMsg($v.lead.primary_phone)}}</div>
              </div>

              <div class="form-group p-2 mb-1">
                <label for="emailAddress">Email Address</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Email Address"
                  ref="emailAddress"
                  v-model="$v.lead.primery_email.$model"
                />
                    <div class="error">{{validationMsg($v.lead.primery_email)}}</div>
              </div>

            </div>
          </div>
          <div class="card">
            <div class="form-group m-0">
              <button type="submit" :disabled="$v.$invalid" class="btn btn-primary btn-block">
                Save
              </button>
            </div>
          </div>
        </b-form>
      </b-container>
    </div>
  </div>
</template>
<script>
import SingleTagInput from "@/components/Forms/SingleTagInput.vue";
import { required, minLength, maxLength, email} from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages'
import { EMPANELMENT_STATUS_IDS } from "@/assets/scripts/utility.js";
const formMessages = {
  required: () => 'Field is required',
  txtMinLen: ({ $params }) => `Must be at least ${$params.txtMinLen.min} characters.`,
  txtMaxLen: ({ $params }) => `Must be at most ${$params.txtMaxLen.max} characters.`,
  email: () => 'Should be valid email',
}

export default {
  components: {
    SingleTagInput,
  },
  name: "AddBroker",
  data: () => {
    return {
      dialog: false,
      lead: {
        full_name: null,
        firm_name: null,
        primery_email: null,
        primary_phone: null,
        locality_id: null,
        status_id: null,
      },
      selectedLocality: {},
      selectedStatus: {},
      hasStatusError: false,
      canShowEmpanelmentDate: false
    };
  },
  validations: {
    lead: {
      full_name: {
        required
      },
      firm_name: {
        required
      },
      primary_phone: {
        required,
        txtMinLen: minLength(8),
        txtMaxLen: maxLength(15)
      },
      primery_email: {
        email
      }
    },
    selectedStatus: {
      required
    },
  },
  methods: {
    createLead() {
      this.lead.locality_id = this.selectedLocality.id;
      this.lead.status_id = this.selectedStatus.id;
      this.$axios
        .post("leads", { lead: this.lead })
        .then((res) => {
          swal({
            title: "Broker Created!",
            icon: "success",
          }).then(this.$router.replace({ name: "Brokers" }));
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
    },
    selectStatus(status) {
      this.selectedStatus = status;
      this.hasStatusError = true
      if (EMPANELMENT_STATUS_IDS.includes(this.selectedStatus.id)){
        this.canShowEmpanelmentDate = true
      }
      else{
        this.canShowEmpanelmentDate = false
      }
    },
    removeStatus() {
      this.selectedStatus = {};
    },
    selectLocality(locality) {
      this.selectedLocality = locality;
    },
    removeLocality() {
      this.selectedLocality = {};
    },
  },
  computed: {
    localityList() {
      console.log(this.$store.getters.localitiesMaster);
      return this.$store.getters.localitiesMaster;
    },
    statusList() {
      return this.$store.getters.statusesMaster;
    },
    validationMsg(){
      return validationMessage(formMessages);
    }
  },
};
</script>
<style  scoped>
label {
  letter-spacing: 0.01em;
  font-size: 14px;
  font-weight: 500;
}
.form-control {
  font-size: 14px;
}
</style>